import { NotEmptyString, NumberGreaterThanOrEqualToZero } from "../../../../Validation/Validation";
import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";

export const DeliveryMethodSchema: ISchema = {
    displayName: "Delivery method",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'name',
            displayName: 'Name',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
            validateRule: NotEmptyString as Function,
            validationError: "Name cannot be empty",
        } as ISchemaProperty,
        {
            name: 'cost',
            displayName: 'Cost (£)',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
            validateRule: NumberGreaterThanOrEqualToZero as Function,
            validationError: "Cost must be 0 or more",
        } as ISchemaProperty,
        {
            name: 'isDigital',
            displayName: 'Is Digital?',
            type: PropertyTypes.bool,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'type',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false
        } as ISchemaProperty
    ],
}
